<template>
  <div>
    <van-sticky>
      <navbar :title="title" />
    </van-sticky>

    <van-form @submit="onSubmit" style="padding-bottom: 50px">
      <van-field v-model="form.client_name" name="客户姓名" label="客户姓名" placeholder="请输入客户姓名"
        :rules="[{ required: true, message: '请填写客户姓名' }]" />
      <van-field v-model="form.client_status_text" name="客户状态" label="客户状态" placeholder="选择客户状态" readonly
        @click="picker.typePicker = true" />
      <van-field v-model="form.contact_person" name="联系人" label="联系人" placeholder="请输入联系人"
        :rules="[{ required: true, message: '请填写联系人' }]" />
      <van-field v-model="form.contact_phone" name="联系电话" label="联系电话" placeholder="请输入联系电话"
        :rules="[{ pattern, message: '请填写正确联系电话' }]" />
      <van-field v-model="form.other_methods" name="其他联系方式" label="其他联系方式" placeholder="请输入其他联系方式"
        :rules="[{ required: true, message: '请填写正确其他联系方式' }]" />
      <van-field v-model="form.wx_id" name="微信ID" label="微信ID" placeholder="请输入微信ID"
        :rules="[{ required: true, message: '请填写微信ID' }]" />
      <van-field v-model="form.address_area" name="地址" label="地址" placeholder="请选择地址" readonly
        @click="picker.areaPicker = true" />
      <van-field v-model="form.address_detailed" name="详细地址" label="详细地址" placeholder="请输入详细地址"
        :rules="[{ required: true, message: '请输入详细地址(街道)' }]" />
      <van-field v-model="form.client_job_text" name="客户职位" label="客户职位" placeholder="选择客户职位" readonly
        @click="picker.clientJobPicker = true" />
      <van-field v-model="form.tag_id_text" name="客户标签" label="客户标签" placeholder="选择客户标签" readonly
        @click="picker.tagIdPicker = true" />
      <van-field v-model="form.client_type_text" name="客户类型" label="客户类型" placeholder="选择客户类型" readonly
        @click="picker.clientTypePicker = true" />
      <van-field v-model="form.client_remark" rows="3" autosize label="备注" type="textarea" placeholder="请输入备注"
        :rules="[{ required: true, message: '请填写备注' }]" />
      <van-field name="uploader" label="微信二维码">
        <template #input>
          <van-uploader v-model="form.uploader" :max-count="1" accept="all" icon="upgrade" />
        </template>
      </van-field>
      <van-field name="radio" label="类型">
        <template #input>
          <van-radio-group v-model="form.type" direction="horizontal">
            <van-radio name="private" checked-color="#07c160">我的客户</van-radio>
            <van-radio name="null" checked-color="#07c160">公共客户</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>

    <van-tabbar v-model="activeName">
      <van-tabbar-item name="list" icon="user-o" to="/customer/list">我的客户</van-tabbar-item>
      <van-tabbar-item name="public" icon="friends-o" to="/customer/publicList">公共客户</van-tabbar-item>
      <van-tabbar-item name="index" icon="add-o" to="/customer">新增客户</van-tabbar-item>
    </van-tabbar>

    <van-popup v-model="picker.typePicker" position="bottom">
      <van-picker show-toolbar :columns="typeList" @cancel="picker.typePicker = false" @confirm="confirmCustomer" />
    </van-popup>
    <van-popup v-model="picker.clientTypePicker" position="bottom">
      <van-picker show-toolbar :columns="clientTypeList" @cancel="picker.clienttypePicker = false"
        @confirm="confirmClienTtype" />
    </van-popup>
    <van-popup v-model="picker.tagIdPicker" position="bottom">
      <van-picker show-toolbar :columns="tagIdList" value-key="tag_name" @cancel="picker.tagidPicker = false"
        @confirm="confirmTagId" />
    </van-popup>
    <van-popup v-model="picker.clientJobPicker" position="bottom">
      <van-picker show-toolbar :columns="clientJobList" @cancel="picker.clientJobPicker = false"
        @confirm="confirmClientJob" />
    </van-popup>
    <van-popup v-model="picker.areaPicker" position="bottom">
      <van-area :area-list="areaList" @cancel="picker.areaPicker = false" value="510100" @confirm="areaConfirm" />
    </van-popup>
  </div>
</template>

<script>
import navbar from "@/components/navBar/index";
// import { addCustomer, tagList } from "@/api/customer";
import { addCustomer } from "@/api/customer";
import province_list from "@/utils/area";
import { Toast } from "vant";
import axios from "axios";
import { getToken } from "@/utils/auth";

export default {
  name: "customer",
  components: {
    navbar,
  },
  data() {
    return {
      title: "新增客户",
      activeName: "index",
      picker: {
        typePicker: false,
        areaPicker: false,
        clientTypePicker: false,
        tagIdPicker: false,
        clientJobPicker: false,
      },
      areaList: province_list,
      pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
      form: {
        requestType: "add_client_list",
        client_name: "",
        client_status: "",
        client_status_text: "",
        client_type: "",
        client_type_text: "",
        tag_id: "",
        tag_id_text: "",
        client_job: "",
        client_job_text: "",
        contact_person: "",
        contact_phone: "",
        address: "",
        address_detailed: "",
        address_area: "",
        client_remark: "",
        type: "private",
        other_methods: "",
        wx_id: "",
        uploader: [],
      },
      typeList: [
        { text: "意向客户", id: 0 },
        { text: "现场确认尺寸和方案", id: 1 },
        { text: "已做报价及方案", id: 2 },
        { text: "需要配合招投标", id: 3 },
        { text: "待签订合同", id: 4 },
        { text: "已签订合同", id: 5 },
        { text: "跟单失败客户", id: 6 },
      ],
      clientTypeList: [
        { text: "工程商", id: 0 },
        { text: "千店服务商", id: 1 },
        { text: "中间商", id: 2 },
        { text: "业主客户", id: 3 },
        { text: "强力经销商调货", id: 4 },
      ],
      clientJobList: [
        { text: "高层管理", id: 0 },
        { text: "中层管理", id: 1 },
        { text: "普通对接人员", id: 2 },
      ],
      tagIdList: [],
    };
  },
  mounted() {
    this.getTagList();
  },
  methods: {
    confirmCustomer(value) {
      console.log(value);
      this.form.client_status_text = value.text;
      this.form.client_status = value.id;
      this.picker.typePicker = false;
    },
    confirmClienTtype(value) {
      this.form.client_type_text = value.text;
      this.form.client_type = value.id;
      this.picker.clientTypePicker = false;
    },
    confirmTagId(value) {
      this.form.tag_id_text = value.tag_name;
      this.form.tag_id = value.tag_id;
      this.picker.tagIdPicker = false;
    },
    confirmClientJob(value) {
      this.form.client_job_text = value.text;
      this.form.client_job = value.id;
      this.picker.clientJobPicker = false;
    },
    areaConfirm(value) {
      console.log(value);
      value.forEach((item) => {
        this.form.address_area = this.form.address_area + item.name;
      });
      this.picker.areaPicker = false;
    },
    onSubmit() {
      // console.log(this.form.uploader.length);
      if (this.form.client_status === "") {
        return Toast("请选择客户状态");
      }
      if (this.form.uploader.length === 0) {
        return Toast("请上传微信二维码");
      }
      this.form.address = this.form.address_area + this.form.address_detailed;
      let formData = new FormData();
      let data = this.form;
      for (let i = 0; i < data.uploader.length; i++) {
        formData.append("file", data.uploader[i].file);
      }
      formData.append("requestType", data.requestType);
      formData.append("client_name", data.client_name);
      formData.append("client_status", data.client_status);
      formData.append("client_type", data.client_type);
      formData.append("contact_person", data.contact_person);
      formData.append("contact_phone", data.contact_phone);
      formData.append("address", data.address);
      formData.append("type", data.type);
      formData.append("client_remark", data.client_remark);
      formData.append("tag_id", data.tag_id);
      formData.append("client_job", data.client_job);
      formData.append("other_methods", data.other_methods);
      formData.append("wx_id", data.wx_id);
      formData.append("token", getToken());
      const config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      axios.post(this.GLOBAL.httpURL, formData, config).then(res => {
        // console.log(res);
        if (res.status === 200) {
          if (res.data.code === 200) {
            Toast.fail("新增客户成功!");
            this.$router.go(-1);
          } else if (res.data.code === 301) {
            Toast.fail("参数验证错误!");
          } else {
            Toast.fail(res.data.msg);
          }
        } else {
          Toast.fail("网路连接错误,请稍后重试!");
        }
      });
      // tagList(this.form)
      //   .then(() => {
      //     for (var key in this.form) {
      // 	if (key == "uploader") {
      // 		this.form[key] = [];
      // 	} else  if (key != "type" && key != "requestType") {
      //         this.form[key] = "";
      //       }
      //     }
      //     Toast.fail("新增客户成功!");
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
    getTagList() {
      addCustomer({
        requestType: "get_customer_tag",
      })
        .then((res) => {
          this.tagIdList = res.obj;
        })
        .catch(() => {
          Toast.fail("数据异常");
        });
    }
  },
};
</script>

<style></style>
